import {postFormData} from '../../utils/request'
import http from '../http'

export default {
  data () {
    return {
      brandList: []
    }
  },

  methods: {
    async loadBrandList () {
      const res = await postFormData(
        `distribution/B2cGoodsInfoController/queryBrand`
      ).catch(res => http.handleHttpError(res, this))

      if (res.data.code === 200) {
        this.brandList = res.data.data.b2cGoodsBrandList
        return
      }

      http.handleEorrorCode(res, this)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/brand.js